var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7095 2.35325L28.2531 0.896985C28.0591 0.702518 27.8355 0.605591 27.5828 0.605591C27.3307 0.605591 27.1072 0.702518 26.9132 0.896985L15.4646 12.3449L4.01656 0.897292C3.82239 0.702825 3.59895 0.605897 3.34653 0.605897C3.09401 0.605897 2.87057 0.702825 2.67651 0.897292L1.22035 2.35365C1.02588 2.54771 0.928955 2.77116 0.928955 3.02368C0.928955 3.276 1.02619 3.49944 1.22035 3.6935L14.7946 17.268C14.9887 17.4622 15.2122 17.5592 15.4646 17.5592C15.717 17.5592 15.9402 17.4622 16.1341 17.268L29.7095 3.6935C29.9036 3.49934 30 3.27589 30 3.02368C30 2.77116 29.9036 2.54771 29.7095 2.35325Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.b0d1432d12b5e2cdab1bf8c72b5cd609.svg";
export { ForwardRef as ReactComponent };